import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { EmailVerificationStatus, useLoginMutation } from '@blockpulse3/graphql/hooks';
import { useErrorToast } from '@blockpulse3/ui/commons';

import { useUser } from '../../providers';
import { CheckEmail } from '../CheckEmail';
import { ILoginForm, LoginForm, LoginFormDefaults } from './LoginForm';

type Props = unknown;

export function LoginView(): JSX.Element {
  const i18nLoginView = useTranslations('LoginView');

  const errorToast = useErrorToast();

  const { loadUser } = useUser();
  const [searchParams] = useSearchParams();
  const [loginMutation] = useLoginMutation();
  const [tokenType, setTokenType] = useState<string>('');
  const [signUpEmail, setSignUpEmail] = useState<string>('');

  const redirectEmail = searchParams.get('email') || '';

  const handleLoginSubmit = (loginData: ILoginForm): void => {
    loginMutation({
      variables: {
        loginInput: {
          email: loginData.email.toLowerCase(),
          password: loginData.password,
          timezone: loginData.timezone,
        },
      },
      onCompleted: (data) => {
        setSignUpEmail(loginData.email);
        setTokenType(data?.login?.process_step || '');
        if (data?.login?.access_token) {
          localStorage.setItem('token', data.login.access_token);
          loadUser();
        }
      },
      onError: () => {
        errorToast({ title: i18nLoginView('ToastDescription') });
      },
    });
  };

  if (tokenType === EmailVerificationStatus.UNVERIFIED) {
    return <CheckEmail email={signUpEmail} />;
  }

  return (
    <LoginForm
      defaultValues={{ ...LoginFormDefaults, email: redirectEmail }}
      onSubmit={handleLoginSubmit}
    />
  );
}

export type LoginViewProps = Props;
